var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "social-icon-section",
      class: {
        "social-icon-section--stacked": _vm.localStacked,
        "social-icon-section-minimal": _vm.minimal,
      },
    },
    [
      _c("h5", { staticClass: "social-icon-header" }, [
        _vm._v(_vm._s(_vm.socialMediaHeaderText)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "social-icons" },
        [
          _vm._l(_vm.socialMediaList, function (item) {
            return [
              item.socialIconLink
                ? _c(
                    "a",
                    {
                      key: item.socialIconLink,
                      staticClass: "social-icon-link",
                      class: item.socialIconType,
                      attrs: { href: item.socialIconLink, target: "_blank" },
                    },
                    [
                      _c("img", {
                        staticClass: "social-icon-image",
                        attrs: {
                          src: _vm.getFullyQualifiedUrl(item.socialIconUrl),
                          alt: item.socialIconType,
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }